module.exports = __webpack_public_path__ + "img/banner.0fa567cd.png";